/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Add dropdown options of multiple key value.
 */

 import Blockly from 'blockly/core';
 import {createPlusField} from './field_plus';
 import {createMinusField} from './field_minus';
import { all } from 'core-js/fn/promise';
 /* eslint-disable quotes */
 Blockly.defineBlocksWithJsonArray([
   {
     "type": "custom_dropdownoptions",
     "appendfield": "Get %1 %2",
     "message0": "%{DROPDOWN_OPTIONS} %1",
     "args0": [
       {
         "type": "input_dummy",
         "name": "EMPTY",
       },
     ],
     "args1": [
       {
         "type": "field_dropdown",
         "name": "DROPDOWN_OPTIONS",
       },
       {
         "type": "input_value",
         "name": "CUSTOM_OPTIONS",
         "align": "CENTRE"
       }
     ],
     "output": "Array",
     "style": "list_blocks",
     "helpUrl": "",
     "tooltip": "Set multiple values in the display of dropdown",
     "mutator": "multiple_option_mutator",
   },
 ]);
 /* eslint-enable quotes */
 
  var multipleOptionMutator = {
   /**
    * Number of item inputs the block has.
    * @type {number}
    */
   itemCount_: 0,
 
   /**
    * Creates XML to represent number of text inputs.
    * @return {!Element} XML storage element.
    * @this {Blockly.Block}
    */
   mutationToDom: function() {
     const container = Blockly.utils.xml.createElement('mutation');
     container.setAttribute('items', this.itemCount_);
     container.setAttribute("dropdown_options", this.getFieldValue("DROPDOWN_OPTIONS"));
     var options = [];
    if(this.getField("DROPDOWN_OPTIONS")) {
         options = this.getField("DROPDOWN_OPTIONS").getOptions(false);
         for (var i = 0; i < options.length; i++) {
             var option_element = Blockly.utils.xml.createElement("option");
             option_element.setAttribute("display-value", options[i][0]);
             option_element.setAttribute("neutral-value", options[i][1]);
             container.appendChild(option_element);
         }
     }
     return container;
   },
   /**
    * Parses XML to restore the text inputs.
    * @param {!Element} xmlElement XML storage element.
    * @this {Blockly.Block}
    */
   domToMutation: function(xmlElement) {
     const targetCount = parseInt(xmlElement.getAttribute('items'), 10);

     this.mutator_saved = [["none", "none"]];

     // Add all the saved options to the mutator-saved list;
     for (var i = 0; i < xmlElement.childNodes.length; i++) {
       var option_element = xmlElement.childNodes[i];
       this.mutator_saved.push([option_element.getAttribute("display-value"), option_element.getAttribute("neutral-value")])
     }

     if (this.getField("DROPDOWN_OPTIONS")) {
       this.getField("DROPDOWN_OPTIONS").generatedOptions_ = this.mutator_saved;
     }
     this.updateShape_(targetCount);
   },
 
   /**
    * Adds inputs to the block until it reaches the target number of inputs.
    * @param {number} targetCount The target number of inputs for the block.
    * @this {Blockly.Block}
    * @private
    */
   updateShape_: function(targetCount) {
     while (this.itemCount_ < targetCount) {
       this.addPart_();
     }
     while (this.itemCount_ > targetCount) {
       this.removePart_();
     }
     this.updateMinus_();
   },
 
   /**
    * Callback for the plus image. Adds an input to the end of the block and
    * updates the state of the minus.
    */
   plus: function() {
     this.addPart_();
     this.updateMinus_();
   },
 
   /**
    * Callback for the minus image. Removes an input from the end of the block
    * and updates the state of the minus.
    */
   minus: function() {
     if (this.itemCount_ == 0) {
       return;
     }
     this.removePart_();
     this.updateMinus_();
   },
 
   // To properly keep track of indices we have to increment before/after adding
   // the inputs, and decrement the opposite.
   // Because we want our first input to be ADD0 (not ADD1) we increment after.
 
   /**
    * Adds an input to the end of the block. If the block currently has no
    * inputs it updates the top 'EMPTY' input to receive a block.
    * @this {Blockly.Block}
    * @private
    */
   addPart_: function() {
     if (this.itemCount_ == 0) {
       this.removeInput('EMPTY');
       this.topInput_ = this.appendValueInput('ADD' + this.itemCount_)
           .appendField(createPlusField(), 'PLUS')
           .appendField("Select Collection Name")
           .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOption), "DROPDOWN_OPTIONS")
           .appendField("Separator: ")
           .appendField(new Blockly.FieldDropdown([["-", "-"],["_", "_"],[",", ","]]), "OPTION_SEPARATOR")
           .appendField(" Map field ");
     } else {
       this.appendValueInput('ADD' + this.itemCount_);
     }
     this.itemCount_++;
   },

   generateOptions: function () {
    let responseDataOptions1 = [['Please select', '']];
    let block = this;
    if (block && block.type == 'custom_dropdownoptions' && block.parentBlock_) {
      var apiBLock = block.findAPIBlock(block.parentBlock_);
      if (apiBLock && apiBLock.responseDataFromAPI) {
        let responseData = block.getCollectionNameResponseData(apiBLock.responseDataFromAPI);
        apiBLock.responseDataFromAPI = responseData;
        let options = block.recursionOnResponseData(responseDataOptions1, responseData);
        return options;
      }
    }
    return responseDataOptions1;
  },
  findAPIBlock: function (block) {
    if (block && block.type == 'set_api_data') {
      return block;
    } else {
      if(block)
      return this.findAPIBlock(block.parentBlock_);
    }
  },

  getCollectionNameResponseData: function (responseData) {
    if (Array.isArray(responseData)) {
      return {
        root: responseData,
      };
    }
    return responseData;
  },

  recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
    if(responseData.length > 0) {
      responseData = responseData[0];
    }
    for (var key in responseData) {

      if (responseData.hasOwnProperty(key)) {
        var elemVal = responseData[key];
        if ((elemVal == null) ||(typeof (elemVal) != 'object')) {
          if (parentkey) {
            arr.push([parentkey + '.' + key, parentkey + '.' + key])
          } else if (parentArrPathKey) {
            let keyPath = parentArrPathKey + '["' + key + '"]';
            arr.push([keyPath, key]);
          } else {
            arr.push([key, key]);
          }
        } else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
          let parentkeynew = parentkey ? parentkey + '.' + key : key;
          arr.push([parentkeynew, parentkeynew]);
          this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
        } else {
          let parentkeynew = parentkey ? parentkey + '.' + key : key;
          this.recursionOnResponseData(arr, elemVal, parentkeynew);
        }
      }
    }
    return arr;
  },
  validateFieldOptions: function (fieldName) {
    return fieldName;
  },
 
   /**
    * Removes an input from the end of the block. If we are removing the last
    * input this updates the block to have an 'EMPTY' top input.
    * @this {Blockly.Block}
    * @private
    */
   removePart_: function() {
     this.itemCount_--;
     this.removeInput('ADD' + this.itemCount_);
     if (this.itemCount_ == 0) {
       this.topInput_ = this.appendDummyInput('EMPTY')
           .appendField(createPlusField(), 'PLUS')
           .appendField(Blockly.Msg['Map field ']);
     }
   },
 
   /**
    * Makes it so the minus is visible iff there is an input available to remove.
    * @private
    */
   updateMinus_: function() {
     const minusField = this.getField('MINUS');
     if (!minusField && this.itemCount_ > 0) {
       this.topInput_.insertFieldAt(1, createMinusField(), 'MINUS');
     } else if (minusField && this.itemCount_ < 1) {
       this.topInput_.removeField('MINUS');
     }
   },

 };
 
 /**
  * Updates the shape of the block to have 3 inputs if no mutation is provided.
  * @this {Blockly.Block}
  */
 const multipleoptionHelper = function() {
   this.getInput('EMPTY').insertFieldAt(0, createPlusField(), 'PLUS');
   this.updateShape_(3);
 };
 
 Blockly.Extensions.registerMutator('multiple_option_mutator',
 multipleOptionMutator, multipleoptionHelper);

 



// WEBPACK FOOTER //
// ./client/assets/scripts/vendor/multi-dropdown-option.js